import { createReducer, on } from '@ngrx/store';

import { INITIAL_NOTIFICATION_STATE } from './notification.constants';
import { NotificationState } from './notification.model';
import {
  NotificationActions,
  NotificationApiActions,
} from './notification.actions';

export const notificationReducer = createReducer(
  INITIAL_NOTIFICATION_STATE,

  on(
    NotificationActions.loadNotifications,
    (state): NotificationState => ({
      notifications: state.notifications,
      unseenCount: state.unseenCount,
      loading: true,
      error: null,
    }),
  ),

  on(
    NotificationApiActions.loadNotificationsSuccess,
    (state, { notifications }): NotificationState => ({
      notifications,
      unseenCount: state.unseenCount,
      loading: false,
      error: null,
    }),
  ),

  on(
    NotificationApiActions.loadNotificationsFailure,
    (state, { error }): NotificationState => ({
      notifications: [],
      unseenCount: state.unseenCount,
      loading: false,
      error,
    }),
  ),

  on(
    NotificationApiActions.loadUnseenCountSuccess,
    (state, { unseenCount }): NotificationState => ({
      notifications: state.notifications,
      unseenCount,
      loading: state.loading,
      error: null,
    }),
  ),

  on(
    NotificationApiActions.loadUnseenCountFailure,
    (state, { error }): NotificationState => ({
      notifications: state.notifications,
      unseenCount: 0,
      loading: state.loading,
      error,
    }),
  ),

  on(
    NotificationApiActions.markAllViewedSuccess,
    (state): NotificationState => ({
      notifications: state.notifications.map((notification) => ({
        ...notification,
        viewed: true,
      })),
      unseenCount: 0,
      loading: state.loading,
      error: null,
    }),
  ),

  on(
    NotificationApiActions.markViewedSuccess,
    (state, { notification }): NotificationState => ({
      notifications: state.notifications.map((existingNotification) =>
        existingNotification.notificationId === notification.notificationId
          ? notification
          : existingNotification,
      ),
      unseenCount: state.unseenCount,
      loading: state.loading,
      error: null,
    }),
  ),

  on(
    NotificationApiActions.markAllViewedFailure,
    NotificationApiActions.markViewedFailure,
    (state, { error }): NotificationState => ({
      notifications: state.notifications,
      unseenCount: state.unseenCount,
      loading: state.loading,
      error,
    }),
  ),
);
